var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"itinerary-staff-pick-events-section"},[_c('h2',{staticClass:"itinerary-staff-pick-events-section__header"},[_vm._v("Not to miss")]),_c('ItineraryStaffPickEvents',{attrs:{"events":_vm.events}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }